export default __webpack_public_path__ + "static/media/digi-kapitaal-nobg.bcd9e489.png";